import { render, staticRenderFns } from "./QuestionScoringCard.vue?vue&type=template&id=98176382&scoped=true"
import script from "./QuestionScoringCard.vue?vue&type=script&lang=js"
export * from "./QuestionScoringCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionScoringCard.vue?vue&type=style&index=0&id=98176382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98176382",
  null
  
)

export default component.exports